import NewInvoicesBody from "../components/newInvoicesPage/NewInvoicesBody";

const NewInvoicesPage = () => {
    return(<NewInvoicesBody/>)
}

export default NewInvoicesPage;